module.exports = __webpack_public_path__ + "static/media/pr-14.9342b6cd.jpeg";